module.exports = __webpack_public_path__ + "static/sniper-0f66613635b538c07b2b070cc76d6153.jpg";